import { render } from "./HeaderMain.vue?vue&type=template&id=7ff1ba73"
import script from "./HeaderMain.vue?vue&type=script&lang=js"
export * from "./HeaderMain.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bogdanov.ea/Documents/goast-auth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__